module.exports = __webpack_public_path__ + "static/media/logo-internal-retina.22199e93.png";